/*
  Product_v1.js propTypes
  extracted from http://localhost:3000/documentation/resources/oaspec.json
  on 2018-04-23T13:43:27.206Z
*/

import { arrayOf, bool, number, object, shape, string } from 'prop-types'

import Flags_v1 from './Flags_v1'
import PriceList_v3 from './PriceList_v3'
import PromotionProduct_v1 from './PromotionProduct_v1'
import StockStatus_v1 from './StockStatus_v1'

export default {
  activeSubstances: string,
  additiveSubstances: string,
  brandId: string,
  brandName: string,
  brandURL: string,
  canonicalURL: string,
  category: string,
  descriptionLong: string,
  descriptionShort: string,
  discount: number,
  displayCode: string,
  documents: arrayOf(shape({})),
  endDateRP: string,
  flags: shape(Flags_v1),
  followUpProductCode: string,
  id: string,
  labels: arrayOf(string),
  manufacturer: string,
  maxAmountInCart: number,
  media: arrayOf(string),
  multiplierRP: number,
  name: string,
  numberOfRatings: number,
  odsPartners: arrayOf(string),
  offerId: string,
  pharmaForm: string,
  pharmaFormId: string,
  prices: PriceList_v3,
  promotion: string,
  promotionProduct: shape(PromotionProduct_v1),
  rating: number,
  redPoints: number,
  redPointsIsActive: bool,
  redPointsMultiplierIsValid: bool,
  showFoodInformation: bool,
  stockStatus: shape(StockStatus_v1),
  subtitle: string,
  thumbnailURL: string,
  title: string,
  topsellerFamId: number,
  unit: string,
  unitPricing: string,
  unitQuantityString: string,
  upid: string,
  variants: arrayOf(shape({})),
  videos: arrayOf(object),
}
